export default "__VITE_ASSET__04cbdb66__"